import { Typography } from '@mui/material';
import { TypographyVariant as Variant } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { ageFromDate } from '../../helpers/utilityFunctions/utilityFunctions';
import { Gender } from '../../model/patient/gender';
import { PatientDetail } from '../../model/patient/patientDetail';

interface PatientNameProps {
  patient?: PatientDetail;
  patientKey: string;
  display?: string;
  variant?: Variant;
  component?: React.ElementType;
}

const defaultPatient: PatientDetail = {
  isComplianceEnabled: false,
  accountGuid: 'unknown',
  accountTypeId: 1,
  dateOfBirth: 'unknown',
  email: 'unknown',
  firstName: 'unknown',
  gender: Gender.Unknown,
  lastName: 'unknown',
  verified: 'unknown',
  weight: 0,
};

function PatientValue({
  patient,
  patientKey,
  display,
  variant,
  component,
}: PatientNameProps): React.JSX.Element {
  const [computedValue, setComputedValue] = useState<string>('');
  const [selectedPatient, setSelectedPatient] =
    useState<PatientDetail>(defaultPatient);

  const variantType = variant ? variant : 'h4';
  const componentType = component ? component : 'h4';

  useEffect(() => {
    setSelectedPatient(patient ? patient : defaultPatient);
  }, [patient]);

  useEffect(() => {
    const value =
      patientKey === 'name'
        ? `${selectedPatient.firstName} ${selectedPatient.lastName}`
        : patientKey === 'gender'
          ? Gender[selectedPatient.gender]
          : patientKey === 'dateOfBirth'
            ? ageFromDate(selectedPatient.dateOfBirth).toString()
            : selectedPatient[patientKey as keyof PatientDetail];

    setComputedValue(value as string);
  }, [patientKey, selectedPatient]);

  return (
    <Typography
      variant={variantType}
      component={componentType} sx={{ display: display }}>
      {computedValue}
    </Typography>
  );
}

export default PatientValue;
